import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './bookContentDetail.index.less';
import { getBookContentById, BookContentDetail, getAllBookContents, BookContent } from '../../services/bookService';

const BookContentDetailPage: React.FC = () => {
  const { contentId } = useParams<{ contentId: string }>();
  const [content, setContent] = useState<BookContentDetail | null>(null);
  const [allContents, setAllContents] = useState<BookContent[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContent = async () => {
      if (contentId) {
        const fetchedContent = await getBookContentById(parseInt(contentId, 10));
        if (fetchedContent) {
          setContent(fetchedContent);
        }
      }
    };

    const fetchAllContents = async () => {
      const contents = await getAllBookContents();
      setAllContents(contents);
    };

    fetchContent();
    fetchAllContents();
  }, [contentId]);

  const currentIndex = allContents.findIndex(c => c.id === content?.id);
  const prevContent = currentIndex > 0 ? allContents[currentIndex - 1] : null;
  const nextContent = currentIndex < allContents.length - 1 ? allContents[currentIndex + 1] : null;

  const navigateTo = (id: number | undefined) => {
    if (id) {
      navigate(`/book/${id}`);
    }
  };

  if (!content) {
    return <div>Loading...</div>;
  }

  return (
    <main className="book-content-detail-container">
      <div className="navigation-buttons">
        <button 
          onClick={() => navigateTo(prevContent?.id)} 
          disabled={!prevContent} 
          className="prev-button"
          aria-label="Go to previous article"
        >
          &#8249;
        </button>
      </div>
      <header className="article-header">
        <span>By Marshal Goldsmith</span> | <span>Published on October 26, 2023</span>
      </header>
      <header>
        <h1 className="content-title">{content.title}</h1>
      </header>
      <section>
        <p className="content-text">{content.description}</p>
      </section>
      {content.images && <img src={content.images} alt={content.title} className="content-image" />}
      <div className="navigation-buttons">
        <button 
          onClick={() => navigateTo(nextContent?.id)} 
          disabled={!nextContent} 
          className="next-button"
          aria-label="Go to next article"
        >
          &#8250;
        </button>
      </div>
    </main>
  );
};

export default BookContentDetailPage;
